import { useEffect, useState } from 'react'


const Confirm = ({ message = null, image = null, actionToYesButton = null, textYesButton = null, textNoButton = null, setShowModal, setConfirmData }) => {
    const [errorMessage,setErrorMessage] = useState(null)

    
    const ActionYesButton = async () => {
        try {
            setErrorMessage(null)
            
            const response = await actionToYesButton()
            
            if (response?.success) {
                await CloseModal()
            } else {
                setErrorMessage(response.message)
            }
        } catch (error) {
            
        }
    }

    const CloseModal = async () => {
        try {
            // Borra la info del estado donde se guardan los datos del registro que se está trabajando
            if (setConfirmData && typeof setConfirmData === 'function') {
                await setConfirmData(null)
            }
            
            if (setShowModal && typeof setShowModal === 'function') {
                await setShowModal(false)
            }
        } catch (error) {
            
        }
    }

    // Detectar la tecla ESC para cerrar el modal
    useEffect(() => {
        const handleEscapeKey = async (event) => {
            if (event.key === 'Escape') {
                await CloseModal()
            }
        }
    
        window.addEventListener('keydown', handleEscapeKey)
    
        return () => {
            window.removeEventListener('keydown', handleEscapeKey)
        }
    }, [])


    return (
        <>
            <div className="cModal__Background" onClick={() => CloseModal()}></div>

            <div className="cModal__Container">
                {/* Contenido del modal */}
                <div className="cModal__Container__Content">
                    <button type='button' className='Btn__Adsl--RedOutline cModal__Container__Content__CloseButton' onClick={() => CloseModal()}>X</button>

                    {/* Contenido del modal si solo es un mensaje de confirmación */}
                    {message && (
                        <>
                            <p className="cModal__Container__Content__Text">{message}</p>

                            {image && (
                                image !== '' && (
                                    <img src={image} className='cModal__Container__Content__Image--Thumbnail' />
                                )
                            )}

                            <div className='cModal__Container__Content__ContainerButtons'>
                                <button type='button' className='Btn__Adsl--Red cModal__Container__Content__ContainerButtons__Button' onClick={() => ActionYesButton()}>{textYesButton}</button>
                                <button type='button' className='Btn__Adsl--RedOutline cModal__Container__Content__ContainerButtons__Button' onClick={() => CloseModal()}>{textNoButton}</button>
                            </div>
                            {errorMessage && errorMessage !== '' && ( <p className='cModal__Container__Content__Text--Error'>{errorMessage}</p> )}
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export { Confirm };